import { type PropsWithChildren, createContext, useContext } from "react"
import type { OptionalBuilder } from "~/services/api/types-utils"
import { not } from "~/utils"
import type { PublicEnvsSchema } from "~/utils/env.types"

type PublicEnvs = Record<PublicEnvsSchema, string>
const EnvsContext = createContext<OptionalBuilder<PublicEnvs>>(null)

type EnvsProviderProps = {
  envs?: PublicEnvs
}

export function EnvsProvider({
  envs,
  children,
}: PropsWithChildren<EnvsProviderProps>) {
  return <EnvsContext.Provider value={envs}>{children}</EnvsContext.Provider>
}

export function useEnv(env: keyof PublicEnvs) {
  const envs = useContext(EnvsContext)

  if (not(envs)) {
    throw new Error("<EnvsProvider /> is not used")
  }

  const theEnv = envs[env]

  if (not(theEnv)) {
    throw new Error(`process.env.${env} is not set.`)
  }
  return theEnv
}
